// extracted by mini-css-extract-plugin
export default {"headerContent":"hs1XL","title":"_PUij"};